import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsBar = ({ selectedCount, onBulkAction, onClearSelection }) => {
  const [selectedAction, setSelectedAction] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  const bulkActionOptions = [
    { value: '', label: 'Seleccionar acción...' },
    { value: 'activate', label: 'Activar usuarios' },
    { value: 'deactivate', label: 'Desactivar usuarios' },
    { value: 'block', label: 'Bloquear usuarios' },
    { value: 'unblock', label: 'Desbloquear usuarios' },
    { value: 'reset-password', label: 'Restablecer contraseñas' },
    { value: 'update-limits', label: 'Actualizar límites' },
    { value: 'delete', label: 'Eliminar usuarios' }
  ];

  const handleExecuteAction = async () => {
    if (!selectedAction) return;

    setIsProcessing(true);
    try {
      await onBulkAction(selectedAction);
      setSelectedAction('');
    } catch (error) {
      console.error('Error executing bulk action:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  const getActionIcon = (action) => {
    const iconMap = {
      activate: 'CheckCircle',
      deactivate: 'XCircle',
      block: 'Lock',
      unblock: 'Unlock',
      'reset-password': 'Key',
      'update-limits': 'Settings',
      delete: 'Trash2'
    };
    return iconMap?.[action] || 'Settings';
  };

  const getActionColor = (action) => {
    const colorMap = {
      activate: 'text-green-600 hover:text-green-700',
      deactivate: 'text-gray-600 hover:text-gray-700',
      block: 'text-red-600 hover:text-red-700',
      unblock: 'text-green-600 hover:text-green-700',
      'reset-password': 'text-blue-600 hover:text-blue-700',
      'update-limits': 'text-purple-600 hover:text-purple-700',
      delete: 'text-red-600 hover:text-red-700'
    };
    return colorMap?.[action] || 'text-gray-600 hover:text-gray-700';
  };

  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
            <Icon name="Users" size={16} color="white" />
          </div>
          <div>
            <div className="text-sm font-medium text-foreground">
              {selectedCount} usuario{selectedCount !== 1 ? 's' : ''} seleccionado{selectedCount !== 1 ? 's' : ''}
            </div>
            <div className="text-xs text-muted-foreground">
              Aplica acciones en lote a los usuarios seleccionados
            </div>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <Select
            placeholder="Seleccionar acción..."
            options={bulkActionOptions}
            value={selectedAction}
            onChange={setSelectedAction}
            className="w-48"
          />
          
          <Button
            variant="default"
            size="sm"
            onClick={handleExecuteAction}
            disabled={!selectedAction || isProcessing}
            loading={isProcessing}
            iconName={selectedAction ? getActionIcon(selectedAction) : "Play"}
            iconPosition="left"
            iconSize={14}
            className={selectedAction ? getActionColor(selectedAction) : ''}
          >
            Ejecutar
          </Button>

          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            iconName="X"
            iconSize={14}
            className="text-muted-foreground hover:text-foreground"
          >
            Limpiar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;